import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscProjectApprovalModalAnalyticIds = {
  resetConfirmBtnId: string;
  resetCancelBtnId: string;
};

export const useAscProjectApprovalModalAnalyticIds = (): AscProjectApprovalModalAnalyticIds => ({
  resetConfirmBtnId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_APPROVAL_RESET_CONFIRM_BUTTON),
  resetCancelBtnId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_APPROVAL_RESET_CANCEL_BUTTON),
});
